<template>
    <button
        class="theme-toggle noselect"
        :aria-label="isDark ? 'Mudar para tema claro' : 'Mudar para tema escuro'"
        :title="isDark ? 'Tema claro' : 'Tema escuro'"
        type="button"
        @click="toggle"
    >
        <span :class="['theme-toggle__slot', !isDark ? 'is-active' : null]">
            <v-icon
                size="16"
                :color="!isDark ? 'primary' : 'on-surface-variant'"
            >
                mdi-white-balance-sunny
            </v-icon>
        </span>
        <span :class="['theme-toggle__slot', isDark ? 'is-active' : null]">
            <v-icon
                size="16"
                :color="isDark ? 'primary' : 'on-surface-variant'"
            >
                mdi-weather-night
            </v-icon>
        </span>
    </button>
</template>

<script>
const STORAGE_KEY = 'app-theme'

export default {
    name: 'ThemeToggle',
    computed: {
        isDark() {
            return this.$vuetify.theme.dark
        },
    },
    methods: {
        toggle() {
            const next = !this.$vuetify.theme.dark
            this.$vuetify.theme.dark = next
            this.applyTheme(next)
            try {
                localStorage.setItem(STORAGE_KEY, next ? 'dark' : 'light')
            } catch (e) { /* ignore */ }
        },
        applyTheme(isDark) {
            if (typeof document === 'undefined') return
            document.documentElement.classList.toggle('theme-dark', isDark)
        },
    },
    mounted() {
        this.applyTheme(this.isDark)
    },
    watch: {
        isDark(v) {
            this.applyTheme(v)
        },
    },
}
</script>

<style scoped>
.theme-toggle {
    display: inline-flex;
    align-items: center;
    gap: 2px;
    padding: 3px;
    border-radius: 9999px;
    background: var(--glass-soft-bg);
    border: 1px solid var(--glass-panel-border);
    cursor: pointer;
    transition: background 200ms ease;
}

.theme-toggle:hover {
    background: rgba(255, 255, 255, 0.6);
}

html.theme-dark .theme-toggle:hover {
    background: rgba(255, 255, 255, 0.08);
}

.theme-toggle__slot {
    width: 28px;
    height: 28px;
    border-radius: 9999px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: background 200ms ease, box-shadow 200ms ease;
}

.theme-toggle__slot.is-active {
    background: var(--color-surface-container-lowest);
    box-shadow: 0 1px 2px rgba(112, 42, 225, 0.18);
}

html.theme-dark .theme-toggle__slot.is-active {
    background: rgba(189, 157, 255, 0.15);
}
</style>
